import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';
import { BaseLandscapeService } from '../../base-landscape.service';
import { EntityBlockMappingSaveRequestDto } from '../dto/request/entity-block-mapping-save-request.dto';
import { ImageBlockSaveRequestDto } from '../dto/request/image-block-save-request.dto';
import { ImageBlockUpdateRequestDto } from '../dto/request/image-block-update-request.dto';
import { RichTextBlockSaveRequestDto } from '../dto/request/rich-text-block-save-request.dto';
import { RichTextBlockUpdateRequestDto } from '../dto/request/rich-text-block-update-request.dto';
import { EntityBlockMappingResponseDto } from '../dto/response/entity-block-mapping-response.dto';
import { ImageBlockResponseDto } from '../dto/response/image-block-response.dto';
import { RichTextBlockResponseDto } from '../dto/response/rich-text-block-response.dto';

class BlockService extends BaseLandscapeService {
  public async fetchBlocks(
    id: string,
    type: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<EntityBlockMappingResponseDto[]> {
    const response = await this.get<EntityBlockMappingResponseDto[]>(`/block`, {
      params: {
        type,
        id,
      },
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async fetchImageBlockById(id: string): Promise<ImageBlockResponseDto> {
    const response = await this.get<ImageBlockResponseDto>(`/block/${id}`);
    return response.data;
  }

  public async fetchRichTextBlockById(
    id: string
  ): Promise<RichTextBlockResponseDto> {
    const response = await this.get<RichTextBlockResponseDto>(`/block/${id}`);
    return response.data;
  }

  public async saveImageBlock(
    saveRequest: ImageBlockSaveRequestDto
  ): Promise<ImageBlockResponseDto> {
    const response = await this.post<ImageBlockResponseDto>(
      `/block`,
      saveRequest
    );
    return response.data;
  }

  public async saveRichTextBlock(
    saveRequest: RichTextBlockSaveRequestDto
  ): Promise<RichTextBlockResponseDto> {
    const response = await this.post<RichTextBlockResponseDto>(
      `/block`,
      saveRequest
    );
    return response.data;
  }

  public async orderBlocks(
    saveRequest: EntityBlockMappingSaveRequestDto[]
  ): Promise<EntityBlockMappingResponseDto[]> {
    const response = await this.post<EntityBlockMappingResponseDto[]>(
      `/block/order`,
      saveRequest
    );
    return response.data;
  }

  public async updateImageBlock(
    updateRequest: ImageBlockUpdateRequestDto
  ): Promise<ImageBlockResponseDto> {
    const response = await this.put<ImageBlockResponseDto>(
      `/block`,
      updateRequest
    );
    return response.data;
  }

  public async updateRichTextBlock(
    updateRequest: RichTextBlockUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<RichTextBlockResponseDto> {
    const response = await this.put<RichTextBlockResponseDto>(
      `/block`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteBlock(
    existingId: string,
    compactId: string
  ): Promise<void> {
    await this.delete<void>(`/block/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const blockService = new BlockService();
export default blockService;
